import { translate } from '@/core/localization/translate';
export const {
  title,
  positiveSubBtnLabel,
  negativeBtnLabel
} = translate({
  "title": "Never miss our good deals, our news, our advice!",
  "positiveSubBtnLabel": "I subscribe",
  "negativeBtnLabel": "No thanks"
});